export const vatCodeLineMutationFrag = `
    id
`;

export const accountFrag = `
    id
    name
`;
